import axios from 'axios'

const API = 'reclamos'

const RECLAMOS = {
    listarPedidos(payload={}){
        return axios(`${API}/listar`,{params: payload })
    },
    detallePedido(payload = {}){
        return axios(`${API}/detalle-pedido`,{params: payload})
    },
    finalizarReclamo(idPedido = {}, vista= 1){
        return axios.put(`${API}/${idPedido}/${vista}/finalizar-reclamo`)
    },
    actualizarUltimaLectura(payload = {}){
        return axios.put(`${API}/actualizar-ultima-lectura`,payload)
    },


}

export default RECLAMOS
